import { render, staticRenderFns } from "./PlanFacts.vue?vue&type=template&id=2f735ac0"
import script from "./PlanFacts.vue?vue&type=script&lang=js"
export * from "./PlanFacts.vue?vue&type=script&lang=js"
import style0 from "./PlanFacts.vue?vue&type=style&index=0&id=2f735ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports